<aix-header-section [title]="'Send for eSign'" [data-testing]="'signing-method-header'">
    <aix-button
        (click)="cancelESign.emit()"
        [data-testing]="'cancel-e-sign'"
        [buttonType]="cancelEsignButtonType"
        [buttonLabel]="'Cancel eSign'"
    >
    </aix-button>
</aix-header-section>

<div>
    @if ((signers() | aixSignerFilter:recipientType.investor)?.length) {
    <h5 class="u-mt16" [data-testing]="'investor-signers-title'">Investors</h5>
    } @for (signer of (signers() | aixSignerFilter:recipientType.investor); track $index) {
    <aix-signer [recipient]="signer"></aix-signer>
    } @if ((signers() | aixSignerFilter:recipientType.additional)?.length) {
    <h5 class="u-mt16" [data-testing]="'additional-signers-title'">Additional Signers</h5>
    } @for (signer of (signers() | aixSignerFilter:recipientType.additional); track $index) {
    <aix-signer [recipient]="signer"></aix-signer>
    } @if ((signers() | aixSignerFilter:recipientType.advisor)?.length) {
    <h5 class="u-mt16" [data-testing]="'investor-signers-title'">Advisors</h5>
    } @for (signer of (signers() | aixSignerFilter:recipientType.advisor); track $index) {
    <aix-signer [recipient]="signer"></aix-signer>
    } @if ((signers() | aixSignerFilter:recipientType.postAdvisor)?.length) {
    <h5 class="u-mt16" [data-testing]="'post-advisor-signers-title'">Additional Signers</h5>
    } @for (signer of (signers() | aixSignerFilter:recipientType.postAdvisor); track $index) {
    <aix-signer [recipient]="signer"></aix-signer>
    }
</div>

<aix-send-message
    #sendMessageComponent
    [type]="'ESign'"
    [states]="states()"
    [recipientError]="recipientError()"
    [useRichText]="false"
    [description]="'This template will be used by default when sending for signatures.'"
    [emailSettings]="store.order.firm?.emailSettings"
    (editOrder)="editOrder()"
>
    <div id="from">
        <div class="aix-form__group">
            <aix-input
                [value]="'AIX Platform via DocuSign ' + docusignEmail + '>'"
                [isValid]="true"
                [isRequired]="true"
                [isDisabled]="true"
            >
                From
            </aix-input>
        </div>
    </div>
    <div id="toolbar">
        <aix-button
            [data-testing]="'send-e-sign-button'"
            (click)="onSubmit()"
            [buttonType]="sendEsignButtonType"
            [buttonLabel]="'Send for eSign'"
            [isDisabled]="sendMessageComponent.sendForm?.invalid || sendMessageComponent.isAssignBoxOpen()"
        >
        </aix-button>
    </div>
</aix-send-message>
